export default {
  status: {
    all: 'All',
    notEmitted: 'Without issuing',
    pending: 'Issue pending',
    error: 'Issuance error'
  }
}
